import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const paramsObject = {};
  params.forEach(function (value, key) {
    paramsObject[key] = value;
  });
  return paramsObject;
};

export default useQueryParams;
